import { giphyDarkGrey } from '@giphy/js-brand'
import React, { useContext } from 'react'
import styled from 'styled-components'
import CreationToolCrop from '../../../types/crop'
import { UploadFieldBlock } from '../../blocks'
import SegmentedControl from '../../segmented-control'
import { Subtitle } from '../../typography'
import { CreationSourceEditorContext } from '../manager'

const CropTypes = styled(UploadFieldBlock)`
    grid-column: span 8;
`

const CropTypesControl = styled(SegmentedControl)`
    background: ${giphyDarkGrey};
`

const CreationSourceEditorCropPanel = () => {
    const { source, cropType, setCropType } = useContext(CreationSourceEditorContext)
    const allCropTypes = CreationToolCrop.all().filter(
        type => CreationToolCrop.aspectRatio(type) !== source.width / source.height
    )

    return (
        <>
            <CropTypes>
                <Subtitle>Crop</Subtitle>
                <CropTypesControl
                    {...{
                        items: allCropTypes.map(CreationToolCrop.title),
                        defaultIndex: allCropTypes.findIndex(type => type === cropType),
                        onIndexChange: index => setCropType(allCropTypes[index]),
                    }}
                />
            </CropTypes>
        </>
    )
}

export default CreationSourceEditorCropPanel
